<!--Navigator:页面以及导航栏 2025/01/15 17:29:16 XIJIGUO-->

<template>
  <div class="yj-navigator">
    <div v-if="!tab.hidden" class="main-tabs">
      <ul>
        <li v-for="(item, index) in navigators" :key="'li' + index" :class="{ active: tab === item }" @click="tabAction(item)">
          <p class="nav-name">{{ item.permName }}</p>
          <p class="nav-active"></p>
        </li>
      </ul>
      <div class="item-right">
        <el-tooltip v-if="isExamListNav && userInfo.isAdmin" class="item" effect="dark" content="回收站" placement="bottom">
          <p class="yj-nav-icon icon-trash" @click="checkPermission(() => { $router.push('/region/exam/single/recycle') })"></p>
        </el-tooltip>
        <el-tooltip v-if="showMultipleReport" class="item" effect="dark" content="自定义报告" placement="bottom">
          <p class="yj-nav-icon icon-report" @click="$router.push('/region/exam/multiple')"></p>
        </el-tooltip>
        <el-tooltip effect="dark" content="去审核" placement="bottom">
          <p v-if="userInfo.isAdmin === 1 && reportCheck" class="yj-nav-icon icon-examine" style="position:relative" @click="checkPermission(() => { $router.push('/region/exam/single/audit') })">
            <span class="btn-tag" v-if="auditExamCount > 0">{{ auditExamCount > 99 ? '99+' : auditExamCount }}</span>
          </p>
        </el-tooltip>
        <el-tooltip effect="dark" content="强制刷新" placement="bottom">
          <p class="yj-nav-icon icon-refresh" @click="loadSite"></p>
        </el-tooltip>
        <el-popover v-if="isSelf" v-model="visible" trigger="hover">
          <p style="margin: 10px 0;">
            {{ userInfo.nickName || userInfo.loginName }} ({{ userInfo.schoolName }})
            <br />
            {{ roleNames }}
          </p>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="visible = false">关闭</el-button>
            <el-button type="primary" size="mini" @click="logout">登出</el-button>
          </div>
          <p slot="reference" class="yj-nav-icon el-icon-user"></p>
        </el-popover>
      </div>
    </div>
    <div v-if="tab.children && tab.children.length > 0" class="sub-tabs">
      <el-tabs style="float:left" v-model="subModuleUrl" @tab-click="subTabAction">
        <el-tab-pane v-for="(item, index) in tab.children" :key="'tab' + index" :label="item.permName" :name="item.moduleUrl"></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import '@wangeditor/editor/dist/css/style.css'
import { baseData } from "@/v2/utils/data";
import { examApi, configApi } from '@/v2/utils/api'

export default {
  name: 'Navigator',
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      list: [],
      fixList: [],
      tab: { children: [] },
      subModuleUrl: '',
      currentRoleId: '',
      visible: false,
      auditExamCount: 0,
      showMultipleReport: false,
      reportCheck: 0,
    }
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      jumpCodes: "jumpCodes"
    }),
    navigators: function () {
      this.activeTab()
      return this.list.filter(item => item.hidden !== true)
    },
    isSelf () {
      return window.self === window.top
    },
    isExamListNav () {
      return this.tab.permName === '考试列表'
    },
    roleNames () {
      return this.userInfo.roles.map(item => item.roleName).join('、')
    }
  },
  mounted () {
    const pathArray = YJ_REGION_STORAGE.getItem('pathArray')
    if (pathArray && (pathArray.includes('Region-Exam-Multiple') || pathArray.includes('City-Exam-Multiple'))) {
      this.showMultipleReport = true
    }
    this.fixList = baseData.getNavigators()
    this.list = this.fixList
    this.getSchoolConfig()
    this.activeTab()
  },
  methods: {
    async getSchoolConfig () {
      let resp = await configApi.getConfigByTypes(this.userInfo.schoolId, ['REPORT_CHECK']);
      if (resp.body && resp.body.length) {
        this.reportCheck = parseInt(resp.body[0].configValue);
        if (this.reportCheck) {
          this.getAuditExamCount();
        }
      }
    },
    // 获取待审核数量
    async getAuditExamCount () {
      let res = await examApi.getAuditExamCount(this.userInfo.schoolId);
      this.auditExamCount = res.body || 0;
    },
    activeTab: function () {
      const { path, meta } = this.$route
      const pathIndexOf = function (item) {
        return path.indexOf(item.moduleUrl) >= 0 || (meta && meta.parentPath && meta.parentPath.indexOf(item.moduleUrl) >= 0)
      }
      const tab = this.list.find(item => pathIndexOf(item))
      if (tab) {
        this.tab = tab
        if (tab.children && tab.children.length > 0) {
          const child = tab.children.find(item => path.indexOf(item.moduleUrl) >= 0)
          if (child) {
            this.subModuleUrl = child.moduleUrl
          }
        }
      } else if (this.list.length) {
        this.tab = this.list[0]
      }
      this.$emit('change-show-children', tab && tab.children && tab.children.length > 0)
    },
    tabAction: function (tab) {
      const hasChildren = tab.children && tab.children.length
      this.$emit('change-show-children', hasChildren)
      if (tab.permName === '大数据中心') {
        window.open('/region' + tab.moduleUrl, '_blank')
      } else if (this.jumpCodes.includes(tab.permCode)) {
        window.open(this.$root.$children[0].getOutLink(tab.moduleUrl), '_self')
      } else if (hasChildren) {
        this.subModuleUrl = tab.children[0].moduleUrl
        this.subTabAction()
      } else {
        this.$router.push(tab.moduleUrl)
      }
      this.tab = tab
    },
    subTabAction: function () {
      this.$router.push(this.subModuleUrl)
    },
    loadSite () {
      location.reload(true)
    },
    logout () {
      const url = process.env.SSO_URL + '/logout?service=' + encodeURIComponent(location.origin + '/sso/logout?service=' + encodeURIComponent(location.origin + '/region/sso-login'))
      window.open(url, '_self')
    },
    async checkPermission (callback) {
      if (this.userInfo.expiredSchool) {
        this.$root.$children[0].showPermissionDialog()
        return
      }

      if (callback) {
        callback()
      }
    },
  }
}
</script>


<style scoped>
.main-tabs {
  background: white;
  color: #1a1a1a;
  height: 54px;
  line-height: 54px;
  font-size: 14px;
  padding: 0 20px;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.yj-navigator .item-right .switch-button {
  border: 1px solid #ffffff;
  cursor: pointer;
  color: #fff;
  font-family: "PingFang SC";
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  text-align: center;
  margin-right: 16px;
  padding: 2px;
}

.yj-navigator .item-right .old-version-button {
  cursor: pointer;
  background: #ffffff;
  font-family: "PingFang SC";
  text-align: center;
  padding: 7px 15px !important;
  color: #2877ff;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  /* 100% */
}

.yj-navigator .item-right .switch-button:active,
.yj-navigator .item-right .switch-button:focus {
  background: #2877ff;
}

.yj-navigator .item-right .btn-tag {
  position: absolute;
  right: -2px;
  top: -8px;
  margin-right: auto;
  line-height: 10px;
  text-align: center;
  font-size: 10px;
  color: #ff4c3b;
}

.yj-navigator ul {
  height: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.yj-navigator li {
  margin-right: 4px;
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
}

li .nav-name {
  height: 28px;
  line-height: 28px;
  border-radius: 8px;
  cursor: pointer;
  padding: 0 12px;
}

li .nav-active {
  display: none;
}

.yj-navigator li:hover .nav-name {
  background: #e4f0ff;
}

.yj-navigator li.active .nav-name {
  background: #2877ff;
  color: white;
}

li.active .nav-active {
  display: inline-block;
  position: absolute;
  width: 16px;
  height: 2px;
  background-color: #2877ff;
  border-radius: 1px;
  left: calc(50% - 8px);
  bottom: 0;
}

.item-right {
  display: flex;
  align-items: center;
}

.el-icon-user {
  font-size: 16px;
}

.el-icon-user:hover {
  color: #2877ff;
}

.role-list {
  width: 100px;
  overflow: hidden;
  height: 30px;
  margin-right: 15px;
}

.role-list >>> .el-input--mini {
  height: 100%;
  line-height: 30px;
}

.role-list >>> .el-input__inner {
  background: transparent;
  color: white;
  border-radius: 15px;
  border-color: white !important;
}

.role-list >>> .el-select__caret {
  color: white;
}

.sub-tabs {
  height: 40px;
  background: white;
  position: fixed;
  top: 54px;
  z-index: 1000;
  left: 0;
  right: 0;
  padding: 0 20px;
}

.sub-tabs >>> .el-tabs,
.sub-tabs >>> .el-tabs__nav,
.sub-tabs >>> .el-tabs__header,
.sub-tabs >>> .el-tabs__nav-scroll,
.sub-tabs >>> .el-tabs__nav-wrap {
  height: 100%;
  padding: 0;
  line-height: 40px;
}

.sub-tabs >>> .el-tabs__active-bar {
  display: none;
}

.sub-tabs >>> .el-tabs__nav-wrap::after {
  background: transparent;
}
</style>


<style>
.yj-nav-icon {
  cursor: pointer;
  height: 16px;
  width: 16px;
  background-size: 100%;
  margin-left: 20px;
}

.icon-trash {
  background-image: url(../../assets/images/nav/trash.png);
}

.icon-trash:hover {
  background-image: url(../../assets/images/nav/trash-active.png);
}

.icon-report {
  background-image: url(../../assets/images/nav/report.png);
}

.icon-report:hover {
  background-image: url(../../assets/images/nav/report-active.png);
}

.icon-refresh {
  background-image: url(../../assets/images/nav/refresh.png);
}

.icon-refresh:hover {
  background-image: url(../../assets/images/nav/refresh-active.png);
}

.icon-examine {
  background-image: url(../../assets/images/nav/examine.png);
}

.icon-examine:hover {
  background-image: url(../../assets/images/nav/examine-active.png);
}

.popper-2-new {
  top: 42px !important;
  left: auto !important;
  right: 90px !important;
}
</style>



// WEBPACK FOOTER //
// src/v2/views/components/Navigator.vue